<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 height100p full-height" header="Optionen">
        <sm-form #form [form]="formInput">
        </sm-form>
        <p-button class="mt-2" icon="fas fa-search" label="Suchen" (onClick)="run()"></p-button>
    </p-panel>
    @if (tabs.length > 0) {
        <p-tabView class="flex-item-fill flex-col" [(activeIndex)]="tabIndex" (onClose)="closeResult($event)">
            @for (tab of tabs; track tab) {
                <p-tabPanel [header]="tab.title" [closable]=true>
                    <app-sim-log-result [searchOptions]="tab.options">
                    </app-sim-log-result>
                </p-tabPanel>        
            }
        </p-tabView>
    }
</div>